import axios from 'axios';

export const getInitialTranslations = (params) => {
  // console.log(params.url, 'params.url');
  return axios.request({
    url: params.url,
    method: 'get',
  });
};

export const getTranslationsForModule = (params) => {
  const folder = params.folder || 'default';
  const module = params.module || 'common';
  return axios
    .request({
      url: `${params.langSrcUrl}/language/${params.lang}/${module}.json`,
      method: 'get',
    })
    .then((response) => {
      const language = { data: {} };
      if (Object.keys(response.data).length > 0) {
        Object.keys(response.data).forEach(function (key) {
          language.data[key] = response.data[key]['label'];
        });
      }
      return language;
    });
};
